// 공통요소
import './assets/css/base/global.scss';
import { mainFn } from './js/components/header';

document.addEventListener('DOMContentLoaded', () => {
  const { listHandler } = mainFn();
  listHandler();
});
